import React, { useEffect } from 'react'
import OrderForm from './OrderForm'
import { useForm, useStepper} from '../../hooks';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Button } from '../../controls';
import { MenuList } from '../Menu';
import { ArrowForwardIos } from '@mui/icons-material';
import { Container } from '@mui/material';

const defaultOrder = {
  orderId: 0,
  clientId: 1,
  paymentMethod: 'cash',
  total: 0,
  deletedOrderItems: '',
  orderItems: [],
}

const Order = () => {

  const {values, setValues, errors, setErrors, handleValueChange, resetForm} = useForm(defaultOrder);
  const { activeStep, isStepOptional, isStepSkipped, handleNext, handleBack, handleSkip, handleReset } = useStepper([]);

  useEffect(() => {
    setValues(prev => ({...prev, total:prev.orderItems.reduce((acc, item) => parseFloat((item.mealPrice * item.quantity) + (acc)), 0)}));
  }, [values.orderItems]);

  const addMeal = meal => {
    const orderItem = {
      orderItemId: 0,
      orderId: defaultOrder.orderId,
      mealId: meal.mealId,
      mealPrice: meal.mealPrice,
      quantity: 1,
    }

    setValues(prev => {
      if (!prev.orderItems.find(item => item.mealId === meal.mealId)) {
        return ({
          ...prev, orderItems: [...prev.orderItems, orderItem]
        })
      } else return prev;
    })
  }

  const deleteMeal = mealId => {
    setValues(prev => ({
        ...prev, orderItems: [...prev.orderItems.filter(item => item.mealId != mealId)]
      }))
  }

  const updateQuantity = (mealId, newQuantity) => {
    if (newQuantity > 0) {
      setValues(prev => {
        const newOrderItems = [...prev.orderItems];
        var i = 0;
        var orderItem;
        newOrderItems.forEach((item, index) => {
          if (item.mealId === mealId) {
            i = index;
            orderItem = item;
          }
        })
        orderItem.quantity = newQuantity;
        newOrderItems.splice(i, 1, orderItem);
        return ({
          ...prev, orderItems: [...newOrderItems]
        })
      })
    }
  }

  const steps = [
    {
      label: 'Select meals',
      component: <MenuList {...{ updateQuantity: updateQuantity, deleteMeal: deleteMeal, addMeal: addMeal, orderItems: values.orderItems }} />
    },
    {
      label: 'Place order',
      component: <OrderForm
          values={values}
          handleValueChange={handleValueChange}
          errors={errors}
          setErrors={setErrors}
          resetForm={resetForm}
        />
    }
  ];

  return (
    <Container maxWidth={'md'} >
      <Typography 
        variant='h3'
        align='center'
        gutterBottom
        marginTop={5} >
        Garson
      </Typography>
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={activeStep} alternativeLabel >
          {steps.map(({label}, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepOptional(index)) {
              labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <Box >
          {steps.map(({component}, index) => {
            if (index === activeStep) return component;
          })}
        </Box>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              {isStepOptional(activeStep) && (
                <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                  Skip
                </Button>
              )}

              <Button sx={{display: (activeStep === steps.length - 1 ? 'none' : 'flex') }} onClick={handleNext} endIcon={<ArrowForwardIos />} >
                {activeStep === steps.length - 1 ? '' : 'Next'}
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Box>
    </Container>
  )
}

export default Order